export const nftsHints = {
  nft: 'A non-fungible token (NFT) is a unit of data stored on a blockchain, that certifies a digital asset to be unique and therefore not interchangeable. NFTs can be used to represent items such as photos, videos, audio, and other types of digital files.',
  collectionName: 'Name of the NFT collection.',
  owners: 'Total number of owners of the NFT collection.',
  created: 'Keyblock height and estimated date and time when the NFT was created.',
  amount: 'Amount of NFTs in the collection.',
  smartContractId: 'Identifier of the smart contract that implements the AEX-141 non-fungible token standard.',
  extensions: 'Extensions that are implemented for this NFT according to the creator of the smart contract.',
  tokenLimit: 'The maximum number of NFTs that can be minted.',
  templateLimit: 'The maximum number of NFTs that can be minted per template.',
  transferHash: 'The hash of the transaction that transferred the NFT.',
  transferTime: 'Keyblock height and estimated date and time when the NFT was transferred',
  transferTokenId: 'The ID of the NFT that was transferred.',
  transferRecipient: 'The recipient of the NFT.',
  transferSender: 'The sender of the NFT.',
  inventoryTemplateId: 'The ID of the NFT template.',
  inventorySupply: 'The number of NFTs that are minted in this template.',
  inventoryLimit: 'The maximum number of NFTs that can be minted in this template.',
  inventoryCreteTransaction: 'The hash of the transaction that created the NFT template.',
  ownersTokenId: 'Unique identifier of the NFT.',
  ownersContractId: 'Unique identifier of the smart contract that implements the AEX-141 non-fungible token standard.',
  ownersOwnerId: 'The account of the owner of the NFT.',
}
